import { Text, type TextProps } from "@mantine/core";
import { currencySymbol, formatAmount } from "../../utils/format";

interface Props extends TextProps {
  value: string | number | null | undefined;
  currency?: string;
}

/** A billing amount for tables/figures: tabular-nums number in normal weight
 *  with a dimmed currency suffix. Pair with a right-aligned table cell. */
export function MoneyCell({ value, currency = "MNT", ...props }: Props) {
  const amount = formatAmount(value);
  if (amount === "—") {
    return <Text component="span" c="dimmed" {...props}>—</Text>;
  }
  return (
    <Text component="span" style={{ fontVariantNumeric: "tabular-nums" }} {...props}>
      {amount}
      <Text component="span" c="dimmed" ml={4} inherit>{currencySymbol(currency)}</Text>
    </Text>
  );
}
